import React from "react";
import axios from "./axios";
import requests from "./request";
import { useState, useEffect } from "react";
import "./Banner.css";

function Banner() {
  const [Movies, setMovies] = useState([]);

  useEffect(() => {
    async function fetchdata() {
      const request = await axios.get(requests.fetchTrending);
      setMovies(
        request.data.results[
          Math.floor(Math.random() * request.data.results.length - 1)
        ]
      );
      return request;
    }
    fetchdata();
  }, []);

  return (
    <header
      className="banner"
      style={{
        backgroundSize: "cover",
        backgroundImage: `url("https://image.tmdb.org/t/p/original/${Movies?.backdrop_path}")`,
        backgroundPosition: "center center",
      }}
    >
      <div className="banner_contents">
        <h1 className="banner_title">
          {Movies.title || Movies?.name || Movies?.orignal_name}
        </h1>
        <div className="banner_buttons">
          <button className="banner_button">Play</button>
          <button className="banner_button">Mylist</button>
        </div>
        <h1 className="banner_description">{Movies?.overview}</h1>
      </div>
      <div className="banner--fade"></div>
    </header>
  );
}

export default Banner;
